import util from '@/utils/util';
// console.log('8888888888888888',util);

const defaultComArgs = {
  token: '125',
  udid: '125',
  productId: '12583c3a-8b32-47e8-b529-5abaf7b67a73',
  vestId: '8b3b2d4a-ce23-42e4-af65-0412422be11a',
  channel: 'test',
  osType: 'android',
  version: '1',
};

export const publicData = {
  // logo:require("@/assets/img/logo.png"),
  projectName: '支付页面',
  getComArgs:
    process.env.NODE_ENV === 'development' || util.getUrlQueryString('testId')
      ? util.jsonToString(defaultComArgs)
      : '',
  payList: [
    {
      payMode: 'alipay',
      supportFlag: true,
      defaultPayFlag: false,
    },
    {
      payMode: 'weChat',
      supportFlag: true,
      defaultPayFlag: true,
    },
  ],
};
